import React from "react";
import "./PopupModal.scss";

const PopupModal = ({ 
  isOpen, 
  onClose, 
  type = "progress", // "progress" or "success"
  title,
  message,
  progress = 0,
  showCloseButton = true 
}) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-modal" onClick={(e) => e.stopPropagation()}>
        <div className="popup-content">
          {type === "progress" ? (
            <>
              <div className="popup-icon progress-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <circle cx="24" cy="24" r="20" stroke="#e5e7eb" strokeWidth="4" fill="none"/>
                  <circle 
                    cx="24" 
                    cy="24" 
                    r="20" 
                    stroke="#0f84ff" 
                    strokeWidth="4" 
                    fill="none"
                    strokeDasharray={`${2 * Math.PI * 20}`}
                    strokeDashoffset={`${2 * Math.PI * 20 * (1 - progress / 100)}`}
                    strokeLinecap="round"
                    transform="rotate(-90 24 24)"
                    className="progress-circle"
                  />
                  <div className="progress-text">{Math.round(progress)}%</div>
                </svg>
              </div>
              <h3 className="popup-title">{title || "Téléchargement en cours..."}</h3>
              <p className="popup-message">{message || "Veuillez patienter pendant le téléchargement du document."}</p>
              <div className="progress-bar-container">
                <div className="progress-bar">
                  <div 
                    className="progress-bar-fill" 
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="popup-icon success-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <circle cx="24" cy="24" r="20" fill="#10b981"/>
                  <path 
                    d="M16 24L22 30L32 18" 
                    stroke="white" 
                    strokeWidth="3" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <h3 className="popup-title">{title || "Succès!"}</h3>
              <p className="popup-message">{message || "L'opération s'est déroulée avec succès."}</p>
            </>
          )}
          
          {showCloseButton && (
            <button className="popup-close-button" onClick={onClose}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopupModal;

